"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var faXmarkLarge = require('@fortawesome/pro-solid-svg-icons/faXmarkLarge');
var reactDialog = require('@radix-ui/react-dialog');
var react = require('react');
var e = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var e__default = /*#__PURE__*/_interopDefaultLegacy(e);

var v=e__default["default"].div`
  margin-left: var(--spacing-x-x-large);
  margin-right: var(--spacing-x-x-large);
  background-color: var(--background-level-1)
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
  flex-direction: column;
`,f=e__default["default"](reactDialog.Title)`
  all: unset;
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
  color: var(--foreground-primary);
  font-size: var(--font-size-x-large);
  font-weight: var(--font-weight-regular);
`,u=e__default["default"](reactDialog.Close)`
  color: var(--foreground-primary);
  position: absolute;
  top: var(--spacing-regular);
  right: var(--spacing-regular);
  border: none;
  background: none;
  cursor: pointer;
  padding: var(--spacing-small);
`,x=e__default["default"].div`
  padding-left: var(--spacing-x-x-large);
  padding-right: var(--spacing-x-x-large);
  padding-top: var(--spacing-x-large);
  overflow-y: auto;
  flex: 1;

  ${({isContentUnder:r})=>e.css`
    border-top: ${r?"1px solid var(--border-default)":"none"};
  `};
`,y=e__default["default"].div``,b=e__default["default"].div`
  padding: var(--spacing-x-x-large);
  padding-top: var(--spacing-x-large);
  box-shadow: var(--elevation-200);
  border-top: 1px solid var(--border-default);
`,C=e__default["default"].div`
  display: flex;
  gap: var(--spacing-small);

  > * {
    flex: 1;
  }
`,h=e__default["default"](reactDialog.Content)`
  @keyframes flyoutContentShow {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0%);
    }
  }

  @keyframes flyoutContentHide {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(100%);
    }
  }

  &[data-state='open'] {
    animation: flyoutContentShow 0.4s cubic-bezier(0, 0.55, 0.45, 1);
  }

  &[data-state='closed'] {
    animation: flyoutContentHide 0.2s cubic-bezier(0.55, 0, 1, 0.45);
  }

  ${chunk2VCHSK65_js.a};
  color: var(--${chunk2VCHSK65_js.b});
  z-index: var(--z-index-200);
  background-color: var(--background-level-1);
  border-radius: var(--border-radius-small, 6px);
  padding-top: var(--spacing-x-x-large);
  position: fixed;
  display: flex;
  gap: var(--spacing-large);
  flex-direction: column;
  width: var(--content-modal-width);
  top: var(--spacing-large);
  bottom: var(--spacing-large);
  right: var(--spacing-large);
  box-shadow: var(--elevation-400);
  overflow: auto;
`,F=e__default["default"](reactDialog.Overlay)`
  @keyframes overlayShow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes overlayHide {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  &[data-state='open'] {
    animation-name: overlayShow;
  }

  &[data-state='closed'] {
    animation-name: overlayHide;
  }

  inset: 0;
  z-index: var(--z-index-200);
  background-color: var(--overlay-100);
  position: fixed;
  animation-duration: 0.3s;
  animation-timing-function: cubic-bezier(0.52, 0.05, 0.48, 1.01);
`;var A=({children:r})=>{let t=react.useRef(null),[i,l]=react.useState(!1);return react.useEffect(()=>{let s=([p])=>{l(p.intersectionRatio<1);},o=t.current,n=new IntersectionObserver(s,{root:t.current,threshold:[0,1]});return o&&n.observe(o==null?void 0:o.firstChild),()=>{o&&n.unobserve(o==null?void 0:o.firstChild);}},[]),jsxRuntime.jsx(x,{ref:t,isContentUnder:i,children:jsxRuntime.jsx(y,{children:r})})},E=A;var T=({children:r,trigger:t,modal:i=!0,open:l,onOpenChange:s,onOpenAutoFocus:o,container:n=document.body,...p})=>jsxRuntime.jsxs(reactDialog.Root,{modal:i,open:l,onOpenChange:s,...p,children:[t&&jsxRuntime.jsx(reactDialog.Trigger,{asChild:!0,children:t}),jsxRuntime.jsxs(reactDialog.Portal,{container:n,children:[jsxRuntime.jsx(F,{}),jsxRuntime.jsxs(h,{onOpenAutoFocus:o,children:[r,jsxRuntime.jsx(u,{children:jsxRuntime.jsx(chunkLXX3SSRV_js.a,{size:"regular",icon:faXmarkLarge.faXmarkLarge})})]})]})]});T.displayName="Flyout";var N={Root:T,Content:E,Description:reactDialog.Description,Close:reactDialog.Close,Title:f,Header:v,Footer:b,Actions:C};

exports.a = N;
